// test1525
(1525 && 0);
